import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api/axios';
import Button from '../components/Button';
import './LoginPage.css';

function LoginPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    rememberMe: false
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setError(''); // 입력 시 에러 메시지 제거
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      console.log('🔄 로그인 요청 시작:', { username: formData.username });

      // 실제 API 호출
      const response = await apiClient.post('/auth/login', {
        username: formData.username,
        password: formData.password
      });

      console.log('📥 서버 응답:', response.data);

      // 로그인 성공
      const { token, username, name, role } = response.data;
      
      // 토큰 및 사용자 정보 저장
      localStorage.setItem('token', token);
      localStorage.setItem('username', username);
      localStorage.setItem('name', name || username);
      localStorage.setItem('role', role);
      localStorage.setItem('isLoggedIn', 'true');
      
      if (formData.rememberMe) {
        localStorage.setItem('rememberMe', 'true');
      }

      // Axios 기본 헤더에 토큰 설정
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;

      console.log('✅ 로그인 성공:', { username, role, name });
      console.log('🔑 토큰 저장 완료');
      
      // 약간의 딜레이 후 관리자 페이지로 이동 (사용자 피드백)
      setTimeout(() => {
        navigate('/admin', { replace: true });
      }, 500);

    } catch (error) {
      console.error('❌ 로그인 실패:', error);
      
      // 에러 메시지 처리
      if (error.response) {
        // 서버 응답이 있는 경우
        console.error('서버 응답 에러:', error.response.status, error.response.data);
        const responseData = error.response.data;
        
        // 응답 데이터가 문자열인지 객체인지 확인
        if (typeof responseData === 'string') {
          setError(responseData);
        } else if (responseData && responseData.message) {
          setError(responseData.message);
        } else if (responseData && responseData.error) {
          setError(responseData.error);
        } else {
          setError('아이디 또는 비밀번호가 올바르지 않습니다.');
        }
      } else if (error.request) {
        // 요청은 전송되었으나 응답이 없는 경우
        console.error('네트워크 에러: 서버 응답 없음');
        setError('서버에 연결할 수 없습니다. 백엔드가 실행 중인지 확인해주세요.');
      } else {
        // 그 외 에러
        console.error('요청 설정 에러:', error.message);
        setError('로그인 처리 중 오류가 발생했습니다.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>관리자 로그인</h1>
          <p>ANEW 관리 시스템</p>
        </div>

        {error && (
          <div className="login-error">
            <span className="error-icon">⚠️</span>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">아이디</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="관리자 아이디를 입력하세요"
              required
              autoComplete="username"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">비밀번호</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="비밀번호를 입력하세요"
              required
              autoComplete="current-password"
              disabled={isLoading}
            />
          </div>

          <div className="form-options">
            <label className="remember-me">
              <input
                type="checkbox"
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={handleChange}
                disabled={isLoading}
              />
              <span>로그인 상태 유지</span>
            </label>
          </div>

          <Button
            type="submit"
            variant="primary"
            size="large"
            fullWidth
            disabled={isLoading}
            loading={isLoading}
          >
            로그인
          </Button>
        </form>

        <div className="login-footer">
          <Button
            onClick={handleBackToHome}
            variant="outline"
            size="medium"
            fullWidth
            disabled={isLoading}
          >
            ← 홈으로 돌아가기
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
